import IconNoti from '@/assets/img/icons/icon_info_blue@2x.png';
import { breakpoint } from '@/helpers/BreakpointHelper';
import styled from 'styled-components';

export const IconNotiText = styled.div``;
export const IconNotiTitle = styled.strong`
  display: block;
  position: relative;
  padding-left: 32px;
  &::before {
    content: '';
    display: block;
    width: 24px;
    height: 24px;
    background: url(${IconNoti}) no-repeat center center;
    background-size: 24px;
    position: absolute;
    left: 0;
    top: 0;
  }
`;
export const IconNotiSub = styled.p`
  padding-left: 32px;
  line-height: 32px;
  ${breakpoint(640)} {
    line-height: normal;
  }
`;
